import "./Header.scss";
import { useContext, useEffect, useState } from "react";
import SingleProduct from "../SingleProduct/SingleProduct"
import {useNavigate,Link} from "react-router-dom"

import {TbCategoryFilled, TbSearch} from "react-icons/tb"
import { CgProductHunt, CgShoppingCart} from "react-icons/cg"
import {AiOutlineHeart} from "react-icons/ai"

import Search from "./Search/Search"
import Cart from "../Cart/Cart"
import {Context} from "../../utils/context"
import { MdCategory } from "react-icons/md";
import { userData } from "../../helpers";
import Login from "../Login/Login";
import Logout from "../Logout/Logout";

const Header = () => {
    
    // const [isLoggin, setIsLoggin] = (false);
    const [scrolled, setScrolled] = useState(false)
    const [showCart, setshowCart] = useState(false)
    const [showSearch, setshowSearch] = useState(false)
    const {cartCount} = useContext(Context)
    const navigate = useNavigate();

    const handleScroll = () => {
        const offset = window.scrollY;
        if(offset > 200){
            setScrolled(true)
        }else{
            setScrolled(false)
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
    },[]);

    const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if user is authenticated
    const jwtToken = localStorage.getItem('jwtToken'); // Assuming you store JWT token in localStorage upon login
    if (jwtToken) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogout = () => {
    // Clear authentication token from localStorage
    localStorage.removeItem('jwtToken');

    // Redirect to the login page or perform any other necessary actions
    window.location.href = '/login'; // Adjust the URL to your login page
    setIsLoggedIn(false); // Update state to reflect logout
  };

    return (
        
    <>
    
         
            <header className={`main-header ${scrolled ? 'sticky-header' : ""}`}>
            <h1>{userData}</h1>
                <div className="header-content">
                    <ul className="left">
                        <li onClick={() => navigate("/")}>Home</li>
                        <li>About</li>
                       
        
                        
                    </ul>
                    <div className="center" onClick={() => navigate("/")}>
                        MYRA_Store
                    </div>
                    <div className="right">
                        <TbSearch onClick={() => setshowSearch(true)} />
                        
                        {/* <Logout onClick={() => navigate('/login')}/> */}
                        <CgProductHunt  onClick={() => navigate("/displayproduct")}/>
                        <span  className="cart-icon" onClick={() => setshowCart(true)}>
                            
                            <CgShoppingCart />
                            <span>{cartCount}</span>
                        </span>
                    </div>
                </div>
            </header>
            { showCart && <Cart setshowCart={setshowCart}/> }
            {showSearch && <Search setshowSearch={setshowSearch}/>}

       
    </>
    );
};

export default Header;
